export default __webpack_public_path__ + "static/media/approve.fd508881.png";